
import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = Cookies.get('adminToken');
  return isAuthenticated ? children : <Navigate to="/admin" replace />;
};

export default ProtectedRoute;
